import type { InvoiceOverview } from '@vy/api-definition';
import React from 'react';
import { Typography } from '@mui/material';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';

type SyncInvoicesAsSalesOrderDialogProps = {
  open: boolean;
  onClose: () => void;
  invoices: InvoiceOverview[];
  onSyncInvoices: () => void;
};

export const SyncInvoicesAsSalesOrderDialog: React.FC<SyncInvoicesAsSalesOrderDialogProps> = ({
  open,
  onClose,
  invoices,
  onSyncInvoices,
}) => {
  const handleSubmitSync = () => {
    onSyncInvoices();
    onClose();
  };

  const invoiceCount = invoices.length;
  const invoiceText = invoiceCount === 1 ? 'invoice' : 'invoices';

  return (
    <VyDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      label="Sync invoices as Sales order?"
      dialogTitleProps={{
        style: {
          borderBottom: '1px solid #e8ebf2',
          fontWeight: '500',
          paddingBottom: '18px',
          marginBottom: 0,
        },
      }}
      cancelButtonText="Cancel"
      ctaText="Yes, sync invoices"
      onSubmit={handleSubmitSync}
      disableDividers
      dialogContentProps={{
        style: { paddingLeft: '24px', paddingRight: '55px' },
      }}
    >
      <Typography>
        {`You're about to sync ${invoiceCount} ${invoiceText} as `}
        <Typography component="span" sx={{
          fontWeight: 600
        }}>
          Sales orders to NetSuite.
        </Typography>
      </Typography>
      <Typography>This process may take a few minutes.</Typography>
      <Typography sx={{
        marginTop: '20px'
      }}>
        You can close this window after confirming and track progress in the Notifications Center.
      </Typography>
    </VyDialog>
  );
};
